import _classCallCheck from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/inherits";
import Zone from "../zone.js";
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */

var InvalidZone =
/*#__PURE__*/
function (_Zone) {
  _inherits(InvalidZone, _Zone);

  function InvalidZone(zoneName) {
    var _this;

    _classCallCheck(this, InvalidZone);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InvalidZone).call(this));
    /**  @private */

    _this.zoneName = zoneName;
    return _this;
  }
  /** @override **/


  _createClass(InvalidZone, [{
    key: "offsetName",

    /** @override **/
    value: function offsetName() {
      return null;
    }
    /** @override **/

  }, {
    key: "formatOffset",
    value: function formatOffset() {
      return "";
    }
    /** @override **/

  }, {
    key: "offset",
    value: function offset() {
      return NaN;
    }
    /** @override **/

  }, {
    key: "equals",
    value: function equals() {
      return false;
    }
    /** @override **/

  }, {
    key: "type",
    get: function get() {
      return "invalid";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);

  return InvalidZone;
}(Zone);

export { InvalidZone as default };